"use client";

import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "../ui/card";
import { Field, FieldError, FieldGroup, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { Checkbox } from "../ui/checkbox";
import { useFormSubmission } from "@/hooks/use-form-submission";
import { PhoneInput } from "../reui/phone-input";
import { useParams, useRouter } from "next/navigation";
import { Country } from "react-phone-number-input";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { formSchema, FormSchemaType } from "@/lib/form-schema";
const brochureFormSchema = formSchema.pick({
  fullName: true,
  contactNumber: true,
  email: true,
  serviceId: true,
  enquiryType: true,
  terms: true
});
type DownloadBrochureFormProps = {
  formType?: "DOWNLOAD_CORPORATE_BROCHURE" | "COURSE_DOWNLOAD_BROCHURE";
  serviceId?: number;
  heading?: string;
  onSuccess?: () => void;
  className?: string;
};
export const DownloadBrochureForm = t0 => {
  const $ = _c(52);
  const {
    serviceId,
    formType,
    heading,
    className,
    onSuccess
  } = t0;
  const router = useRouter();
  const {
    country
  } = useParams();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = zodResolver(brochureFormSchema);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== serviceId) {
    t2 = serviceId ? [serviceId] : [];
    $[1] = serviceId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = formType || serviceId ? "COURSE_DOWNLOAD_BROCHURE" : "DOWNLOAD_CORPORATE_BROCHURE";
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      resolver: t1,
      defaultValues: {
        fullName: "",
        contactNumber: "",
        email: "",
        serviceId: t2,
        enquiryType: t3,
        terms: false
      }
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const form = useForm(t4);
  let t5;
  if ($[6] !== form || $[7] !== onSuccess || $[8] !== router) {
    t5 = t6 => {
      const {
        name,
        message
      } = t6;
      form.reset();
      onSuccess?.();
      sessionStorage.setItem("thankYouData", JSON.stringify({
        name,
        message
      }));
      router.push("/thank-you-for-enquiry");
    };
    $[6] = form;
    $[7] = onSuccess;
    $[8] = router;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== form.setError || $[11] !== t5) {
    t6 = {
      setError: form.setError,
      onSuccess: t5
    };
    $[10] = form.setError;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const {
    submit,
    isSubmitting
  } = useFormSubmission(t6);
  let t7;
  if ($[13] !== submit) {
    t7 = async function onSubmit(data) {
      await submit(data);
    };
    $[13] = submit;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const onSubmit = t7;
  let t8;
  if ($[15] !== className) {
    t8 = cn("ring-0", className);
    $[15] = className;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = heading ?? "Download Brochure";
  let t10;
  if ($[17] !== t9) {
    t10 = <CardHeader><CardTitle>{t9}</CardTitle></CardHeader>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== form || $[20] !== onSubmit) {
    t11 = form.handleSubmit(onSubmit);
    $[19] = form;
    $[20] = onSubmit;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== form.control) {
    t12 = <Controller name="fullName" control={form.control} render={_temp} />;
    $[22] = form.control;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== country) {
    t13 = t14 => {
      const {
        field: field_0,
        fieldState: fieldState_0
      } = t14;
      return <Field data-invalid={fieldState_0.invalid}><FieldLabel htmlFor="form-rhf-demo-contactNumber">Phone</FieldLabel><PhoneInput defaultCountry={country ? country.toUpperCase() as Country : "US"} international={true} {...field_0} id="form-rhf-demo-contactNumber" aria-invalid={fieldState_0.invalid} placeholder="Please enter your mobile number" autoComplete="off" required={true} />{fieldState_0.invalid && <FieldError errors={[fieldState_0.error]} />}</Field>;
    };
    $[24] = country;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== form.control || $[27] !== t13) {
    t14 = <Controller name="contactNumber" control={form.control} render={t13} />;
    $[26] = form.control;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  let t16;
  if ($[29] !== form.control) {
    t15 = <Controller name="email" control={form.control} render={_temp2} />;
    t16 = <Controller name="terms" control={form.control} render={_temp3} />;
    $[29] = form.control;
    $[30] = t15;
    $[31] = t16;
  } else {
    t15 = $[30];
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t12 || $[33] !== t14 || $[34] !== t15 || $[35] !== t16) {
    t17 = <FieldGroup>{t12}{t14}{t15}{t16}</FieldGroup>;
    $[32] = t12;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t11 || $[38] !== t17) {
    t18 = <CardContent className="mt-auto"><form id="download-brochure-form" onSubmit={t11}>{t17}</form></CardContent>;
    $[37] = t11;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== form || $[41] !== onSubmit) {
    t19 = form.handleSubmit(onSubmit);
    $[40] = form;
    $[41] = onSubmit;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  const t20 = isSubmitting ? "Submitting..." : "Submit";
  let t21;
  if ($[43] !== isSubmitting || $[44] !== t19 || $[45] !== t20) {
    t21 = <CardFooter className="bg-card border-0"><Field orientation="horizontal"><Button type="submit" disabled={isSubmitting} onClick={t19}>{t20}</Button></Field></CardFooter>;
    $[43] = isSubmitting;
    $[44] = t19;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t10 || $[48] !== t18 || $[49] !== t21 || $[50] !== t8) {
    t22 = <Card className={t8}>{t10}{t18}{t21}</Card>;
    $[47] = t10;
    $[48] = t18;
    $[49] = t21;
    $[50] = t8;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  return t22;
};
function _temp(t0) {
  const {
    field,
    fieldState
  } = t0;
  return <Field data-invalid={fieldState.invalid}><FieldLabel htmlFor="form-rhf-demo-fullName">Full Name</FieldLabel><Input {...field} id="form-rhf-demo-fullName" aria-invalid={fieldState.invalid} placeholder="Please enter your full name" autoComplete="off" required={true} />{fieldState.invalid && <FieldError errors={[fieldState.error]} />}</Field>;
}
function _temp2(t0) {
  const {
    field: field_1,
    fieldState: fieldState_1
  } = t0;
  return <Field data-invalid={fieldState_1.invalid}><FieldLabel htmlFor="form-rhf-demo-email">Email ID</FieldLabel><Input {...field_1} id="form-rhf-demo-email" aria-invalid={fieldState_1.invalid} placeholder="Please enter your email ID" autoComplete="off" required={true} />{fieldState_1.invalid && <FieldError errors={[fieldState_1.error]} />}</Field>;
}
function _temp3(t0) {
  const {
    field: field_2,
    fieldState: fieldState_2
  } = t0;
  return <Field data-invalid={fieldState_2.invalid} orientation="horizontal"><Checkbox id="form-rhf-demo-terms" name={field_2.name} checked={field_2.value} onCheckedChange={field_2.onChange} /><FieldLabel htmlFor="form-rhf-demo-terms" className="font-normal"><span>I agree to Spoclearn{" "}<Link href="/terms-and-conditions" className="text-primary font-semibold">terms of use</Link>{" "}and privacy policy</span></FieldLabel>{fieldState_2.invalid && <FieldError errors={[fieldState_2.error]} />}</Field>;
}